import React, { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { lensProp, set, lensPath } from "ramda";
import { notBlank } from "../../../util/ext";

import { MediaContext } from "../../common/media-context";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    flexGrow: 1,
    flexBasis: "100%",
    padding: theme.spacing(3),
  },

  header: {
    textTransform: "uppercase",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.primary.darker,
    marginBottom: theme.spacing(2),
  },

  buttonArea: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  button: {
    backgroundColor: "#127DA9",
  },

  form: {
    marginTop: theme.spacing(3),
  },
}));

const UploadColumn = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const { name, formBuilder, className } = props;

  const handleBlur = (field, value) => {
    context.setErrors(prev =>
      context.validator.validateField(context.media.type, field, value, prev),
    );
  };

  const handleTextChange = path => event => {
    const value =
      notBlank(event) && notBlank(event.target) ? event.target.value : event;
    context.setMedia(prev => set(lensPath(path), value, prev));
  };

  const handleAutocompleteChange = (field, path) => (_event, option) => {
    const value = field === null ? option : option[field];
    context.setMedia(prev => set(lensPath(path), value, prev));
  };

  const handleDateChange = field => value => {
    context.setMedia(prev => set(lensProp(field), value, prev));
  };

  const handleCheckboxChange = field => event => {
    const value = event.target.checked;
    context.setMedia(prev => set(lensProp(field), value, prev));
  };

  return (
    <div className={className || classes.root}>
      {notBlank(name) && <div className={classes.header}>{name}</div>}
      {notBlank(context.media) &&
        formBuilder({
          onTextChange: handleTextChange,
          onDateChange: handleDateChange,
          onCheckboxChange: handleCheckboxChange,
          onAutocompleteChange: handleAutocompleteChange,
          onBlur: handleBlur,
        })}
    </div>
  );
};

export default UploadColumn;
